import { render, staticRenderFns } from "./DialogLookProgress.vue?vue&type=template&id=4a8972a4&scoped=true&"
import script from "./DialogLookProgress.vue?vue&type=script&lang=js&"
export * from "./DialogLookProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8972a4",
  null
  
)

export default component.exports